import { Platform } from '.';
import getSiteHost from '../services/getSiteHost';
import { IUserInfo } from '../services/getUserInfo';
import { getLangSwitchList } from '@umu/umu-lang-switch';
import { getDeviceLinkRules } from './deviceUrl';

const siteHost = getSiteHost();

// navByPlatform 由 SSR 下发（pageController.ts proxyPass），没有时退回 fetch 兜底。
type NavConfig = { header: unknown; footer: unknown };

function getEmbeddedNavConfig(platform: Platform): NavConfig | null {
    if (typeof window === 'undefined') return null;
    const navByPlatform = (window as any)?.pageData?.config?.navByPlatform;
    return navByPlatform?.[platform] ?? null;
}

function createPromiseCache<T>(fn: () => Promise<T>): () => Promise<T> {
    let cachePromise: Promise<T> | null = null;
    return function () {
        if (!cachePromise) {
            cachePromise = fn();
        }
        return cachePromise;
    };
}
/** header footer 只调用一次，避免重复请求 */
const getPageConfig = createPromiseCache(async () => {
    const url = '/napi/v1/home/get-page-data';
    const res = await fetch(url);
    const data = await res.json();
    if (data.error_message) {
        throw new Error(data.error_message);
    }
    try {
        return JSON.parse(data.data.config);
    } catch (e) {
        console.warn('[headerFooterRender] Failed to parse page config:', e);
        return null;
    }
});

type InitHeaderProps = {
    isMobile: boolean;
    userInfo?: IUserInfo;
}
export const initHeader = async ({ isMobile, userInfo }: InitHeaderProps) => {
    const platform = isMobile ? Platform.MOBILE : Platform.TWWW;
    const pageConfig = getEmbeddedNavConfig(platform) ?? (await getPageConfig());
    if (!pageConfig) return;
    const options = {
        platform,
        siteHost,
        lang: LOCALE.toLowerCase(),
        langOptions: getLangSwitchList().map((e) => {
            return {
                text: e.value,
                val: e.key,
            };
        }),
        system: SYSTEM.toLowerCase(),
        isLogin: !!userInfo,
        userInfo: userInfo ? userInfo : undefined,
        headerData: pageConfig.header,
        // 设备链接规则：header 内站内链接按访问设备生成 0 跳地址
        deviceLinkRules: getDeviceLinkRules(),
    };
    if (!window.HomeHeader?.render) {
        console.warn('[headerFooterRender] HomeHeader.render is not available');
        return;
    }
    const headerRenderer = window.HomeHeader.render;
    /**
     * 注意：在应用到的页面html中，确保存在挂载对象，若不存在这手动加上相应标签
     */
    headerRenderer(options as any, document.querySelector('.page-header') as HTMLElement);
};

type InitFooterProps = {
    isMobile: boolean;
}
export const initFooter = async({ isMobile }: InitFooterProps) => {
    if (!window.HomeFooter?.render) {
        console.warn('[headerFooterRender] HomeFooter.render is not available');
        return;
    }
    const footerRenderer = window.HomeFooter.render;
    const platform = isMobile ? Platform.MOBILE : Platform.TWWW;
    const pageConfig = getEmbeddedNavConfig(platform) ?? (await getPageConfig());
    if (!pageConfig) return;

    /**
     * 注意：在应用到的页面html中，确保存在挂载对象，若不存在这手动加上相应标签
     */
    footerRenderer(
        {
            platform,
            siteHost,
            lang: LOCALE.toLowerCase(),
            langOptions: getLangSwitchList().map((e) => {
                return {
                    text: e.value,
                    val: e.key,
                };
            }),
            system: SYSTEM.toLowerCase(),
            footerData: pageConfig.footer,
            deviceLinkRules: getDeviceLinkRules(),
        },
        document.querySelector('.page-footer') as HTMLElement,
    );
};